
import { get, post, fileShowPost, uploadFilePost, fileDownloadPost } from '@/utils/http/Http';
import {
    loginApiUri,
    homeDateUri,
    menuUri,
    merchantListUri,
    createMerchantUri,
    updateMerchantUri,
    whitelistMerchantUri,
    setWhitelistMerchantUri,
    getOrderListBySearchUri,
    getOrderStatusListUri,
    getCabinetListBySearchUri,
    getCabinetSlotsUri,
    getSimpleMerchantListUri,
    getPlanListUri,
    forcePopCabinetUri,
    getSimplePlanListUri,
    updateCabinetUri,
    updatePlanUri,
    getPlayerListUri,
    getPhoneListUri,
    refundOrderUri,
    updateCabinetSlotDisabledUri,
    createPlanUri,
    unbindMerchantUri,
    updatePlayerUri,
    getStatisticsMerchantUri,
    checkCabinetUri,
    completeOrderUri,
    commandListUri,
    updateCommandListUri,
    versionListUri,
    updateVersionAndCommandListRelationUri,
    sendCommandForDeviceUri
} from '@/utils/http/ApiUri';

// /** 登录 */
// export async function loginApi(data) {
//     return await post(agentLoginApiUri, data)
// }
export async function loginApi(data) {
    return await post(loginApiUri, data);
}

export async function homeDate(data) {
    return await get(homeDateUri, data);
}

export async function menu(data) {
    return await get(menuUri, data);
}

export async function merchantList(data) {
    return await post(merchantListUri, data);
}
export async function createMerchant(data) {
    return await post(createMerchantUri, data);
}

// updateMerchantUri
export async function updateMerchant(data) {
    return await post(updateMerchantUri, data);
}


// whitelistMerchantUri
export async function whitelistMerchant(data) {
    return await post(whitelistMerchantUri, data);
}

// setWhitelistMerchantUri;
export async function setWhitelistMerchant(data) {
    return await post(setWhitelistMerchantUri, data);
}

// getOrderListBySearchUri;
export async function getOrderListBySearch(data) {
    return await post(getOrderListBySearchUri, data);
}


export async function getOrderStatusList(data) {
    return await get(getOrderStatusListUri, data);
}

export async function getCabinetListBySearch(data) {
    return await post(getCabinetListBySearchUri, data);
}

// getCabinetSlotsUri;
export async function getCabinetSlots(data) {
    return await post(getCabinetSlotsUri, data);
}

// getSimpleMerchantListUri;
export async function getSimpleMerchantList(data) {
    return await post(getSimpleMerchantListUri, data);
}

// getPlanListUri;
export async function getPlanList(data) {
    return await post(getPlanListUri, data);
}

// forcePopCabinetUri;
export async function forcePopCabinet(data) {
    return await post(forcePopCabinetUri, data);
}


// getSimplePlanListUri
export async function getSimplePlanList(data) {
    return await post(getSimplePlanListUri, data);
}


export async function updateCabinet(data) {
    return await post(updateCabinetUri, data);
}
export async function updatePlan(data) {
    return await post(updatePlanUri, data);
}

export async function getPlayerList(data) {
    return await post(getPlayerListUri, data);
}


export async function getPhoneList(data) {
    return await post(getPhoneListUri, data);
}


export async function refundOrder(data) {
    return await post(refundOrderUri, data);
}

export async function updateCabinetSlotDisabled(data) {
    return await post(updateCabinetSlotDisabledUri, data);
}

export async function createPlan(data) {
    return await post(createPlanUri, data);
}

export async function unbindMerchant(data) {
    return await post(unbindMerchantUri, data);
}

export async function updatePlayer(data) {
    return await post(updatePlayerUri, data);
}


export async function getStatisticsMerchant(data) {
    return await get(getStatisticsMerchantUri, data);
}

export async function checkCabinet(data) {
    return await post(checkCabinetUri, data);
}

export async function completeOrder(data) {
    return await post(completeOrderUri, data);
}

export async function commandList(data) {
    return await get(commandListUri, data);
}

export async function updateCommandList(data) {
    return await post(updateCommandListUri, data);
}
export async function versionList(data) {
    return await post(versionListUri, data);
}

export async function updateVersionAndCommandListRelation(data) {
    return await post(updateVersionAndCommandListRelationUri, data);
}

export async function sendCommandForDevice(data) {
    return await post(sendCommandForDeviceUri, data);
}